import type { ComponentType, FunctionComponent } from "react";
import { useEffect, useState } from "react";

import { connect } from "react-redux";

import ColorStack from "app/components/colorsStack/ColorStack";
import type { ThunkDispatchCommon } from "single-spa/store/types";

import { tableActionsCreator } from "../../../actions/tableActions";
import { CHART_COLORS } from "../../../constants/ChartColors";

import { SWReactTable } from "./SWReactTable";
import { SWReactTableWithSelection } from "./SWReactTableWrapperWithSelection";

interface IMultiColorSelectionTableProps {
    selectedRows?: any[];
    resetSelectedRows?: (tableSelectionKey: string) => void;
    tableData: any;
    isLoading?: boolean;
    tableSelectionKey: string;
    tableSelectionProperty: string;
    tableProps: any;
    params?: any;
}
const chartMainColors = new ColorStack(CHART_COLORS.chartMainColors);

const MultiColorSelectionTable: FunctionComponent<IMultiColorSelectionTableProps> = (props) => {
    const { isLoading, tableProps, selectedRows, tableData } = props;
    const MAX_SELECTED_ROWS = 7;
    const [userToggledRow, setUserToggledRow] = useState(false);
    useEffect(() => {
        props.resetSelectedRows?.(props.tableSelectionKey);
        chartMainColors.reset();
    }, [props.params]);

    const onBeforeRowSelectionToggle = (row: FixmeType) => {
        setUserToggledRow(true);
        if (row.selected) {
            chartMainColors.release(row.selectionColor);
            tableData.map((tableRow: FixmeType) => {
                if (tableRow.index === row.index) {
                    delete tableRow.selectionColor;
                    return;
                }
            });
            return row;
        }
        return {
            ...row,
            selectionColor: row.selectionColor ? row.selectionColor : chartMainColors.acquire(),
        };
    };

    let initialSelectedRows = [];
    if (!isLoading && tableData) {
        initialSelectedRows =
            selectedRows && (selectedRows.length > 0 || userToggledRow)
                ? selectedRows
                : tableData.filter((dataItem: FixmeType, index: number) => {
                      // set color for this row if it still doesn't have one
                      if (!dataItem.selectionColor && index < MAX_SELECTED_ROWS) {
                          dataItem.selectionColor = chartMainColors.acquire();
                      }
                      return index < MAX_SELECTED_ROWS;
                  });
    }

    return (
        <>
            {isLoading ? (
                <SWReactTable {...tableProps} />
            ) : (
                <SWReactTableWithSelection
                    tableSelectionKey={props.tableSelectionKey}
                    tableSelectionProperty={props.tableSelectionProperty}
                    initialSelectedRows={initialSelectedRows}
                    maxSelectedRows={MAX_SELECTED_ROWS}
                    onBeforeRowSelectionToggle={onBeforeRowSelectionToggle}
                    {...tableProps}
                />
            )}
        </>
    );
};

function mapDispatchToProps(dispatch: ThunkDispatchCommon) {
    return {
        resetSelectedRows: (tableSelectionKey: string) => {
            dispatch(tableActionsCreator(tableSelectionKey, "").clearAllSelectedRows());
        },
    };
}

function mapStateToProps({ routing: { params } }: FixmeType) {
    return {
        params,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MultiColorSelectionTable as ComponentType<any>);
